import { createFileRoute } from "@tanstack/react-router";
import Upload from "@/pages/Upload";
import { MainLayout } from "@/components/layout/MainLayout";
import { ProtectedRoute } from "@/components/auth/ProtectedRoute";

export const Route = createFileRoute("/upload")({
  head: () => ({
    meta: [
      { title: "Upload Data | Statlign" },
      { name: "description", content: "Upload match data files for analysis." },
      { property: "og:title", content: "Upload Data | Statlign" },
      { property: "og:type", content: "website" },
      { property: "og:description", content: "Upload match data files for analysis." },
      { name: "twitter:title", content: "Upload Data | Statlign" },
      { name: "twitter:description", content: "Upload match data files for analysis." },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: () => (
    <MainLayout>
      <ProtectedRoute requiredRole="admin">
        <Upload />
      </ProtectedRoute>
    </MainLayout>
  ),
});
